/** 用 JS 获取全局 css 变量 */
export const getCssVariableValue = (cssVariableName: string) => {
  let cssVariableValue = '';
  try {
    // 没有拿到值时，会返回空串
    cssVariableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariableName);
  } catch (error) {
    console.error(error);
  }
  return cssVariableValue;
};

/** 用 JS 设置全局 CSS 变量 */
export const setCssVariableValue = (cssVariableName: string, cssVariableValue: string) => {
  try {
    document.documentElement.style.setProperty(cssVariableName, cssVariableValue);
  } catch (error) {
    console.error(error);
  }
};

// 时间随机id
export const generateRandomTimeId = () => {
  const time = new Date().toISOString();
  const randomNumber = Math.floor(Math.random() * 1000000);
  // 将时间戳和随机数拼接起来，形成一个13位的随机id
  const randomId = time + '-' + randomNumber;
  return randomId;
};

// sleep函数
export const sleep = (delay: number) => {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, delay);
  });
};

// 随机生成key函数
export const randomKey = (bit: number) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < bit; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  return result;
};

export const getTextWidth = (text: string, fontWeight: number, fontSize: number, fontFamily: string) => {
  const span = document.createElement('span');
  span.style.position = 'absolute';
  span.style.visibility = 'hidden';
  span.style.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
  span.textContent = text;
  document.body.appendChild(span);
  const width = span.clientWidth;
  document.body.removeChild(span);
  return width;
};
